/* ==========================================================
   Landing Page Styles
   ========================================================== */

.lp-step-icon { color: var(--color-accent); display: flex; justify-content: center; }
.lp-container-fluid { overflow: hidden; }
.lp-showcase-icon { color: var(--color-accent); }
.lp-features-light { background-color: #F8FAFC; }
.lp-feature-card-link { text-decoration: none; color: inherit; display: block; }
.lp-feature-icon-primary { background-color: var(--color-primary); }
.lp-feature-link-spaced { margin-top: 16px; }

/* ===== SCROLL ANIMATIONS ===== */
.lp-reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.7s cubic-bezier(0, 0, 0.2, 1), transform 0.7s cubic-bezier(0, 0, 0.2, 1);
}
.lp-reveal.visible {
  opacity: 1;
  transform: translateY(0);
}
.lp-reveal-delay-1 { transition-delay: 0.1s; }
.lp-reveal-delay-2 { transition-delay: 0.2s; }
.lp-reveal-delay-3 { transition-delay: 0.3s; }

/* ===== NAVBAR ===== */
.lp-navbar {
  position: fixed;
  top: var(--demo-banner-height, 43px);
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 16px 0;
  transition: all 0.35s ease;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0) 100%);
}
.lp-navbar.scrolled {
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(227, 232, 238, 0.5);
  padding: 12px 0;
  box-shadow: var(--shadow-sm);
}
.lp-navbar .lp-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lp-navbar-logo {
  font-family: var(--font-heading);
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  transition: color 0.35s;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}
.lp-navbar.scrolled .lp-navbar-logo { color: var(--color-text-primary); }
.lp-logo-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--gradient-accent);
  display: inline-block;
}
.lp-navbar-links {
  display: flex;
  align-items: center;
  gap: 32px;
  list-style: none;
  margin: 0 auto;
  padding: 0;
}
.lp-navbar-links a {
  font-size: 15px;
  font-weight: 500;
  color: rgba(255,255,255,0.75);
  transition: color 0.25s;
  position: relative;
  text-decoration: none;
}
.lp-navbar-links a::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--gradient-accent);
  border-radius: 2px;
  transition: width 0.3s var(--ease-spring);
}
.lp-navbar-links a:hover::after { width: 100%; }
.lp-navbar.scrolled .lp-navbar-links a { color: var(--color-text-secondary); }
.lp-navbar-links a:hover { color: #fff; }
.lp-navbar.scrolled .lp-navbar-links a:hover { color: var(--color-accent); }

.lp-navbar .language-switcher { color: rgba(255, 255, 255, 0.8); }
.lp-navbar .language-switcher:hover { color: #fff; }
.lp-navbar.scrolled .language-switcher { color: var(--color-text-secondary); }
.lp-navbar.scrolled .language-switcher:hover { color: var(--color-accent); }

.lp-navbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lp-btn-ghost {
  padding: 10px 20px;
  border-radius: var(--radius-full);
  font-size: 14px;
  font-weight: 600;
  color: rgba(255,255,255,0.9);
  background: transparent;
  border: 1px solid rgba(255,255,255,0.2);
  transition: all 0.25s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}
.lp-btn-ghost:hover {
  background: rgba(255,255,255,0.1);
  border-color: rgba(255,255,255,0.4);
}
.lp-navbar.scrolled .lp-btn-ghost {
  color: var(--color-text-secondary);
  border-color: var(--color-border);
}
.lp-navbar.scrolled .lp-btn-ghost:hover {
  background: var(--color-bg);
  border-color: var(--color-accent);
  color: var(--color-accent);
}
.lp-btn-primary {
  padding: 10px 24px;
  border-radius: var(--radius-full);
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: var(--gradient-accent);
  border: none;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(99,91,255,0.25);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.lp-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 24px rgba(99,91,255,0.3);
}

.lp-btn-outline-secondary {
  padding: 8px 16px;
  border-radius: var(--radius-full);
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  background: #fff;
  border: 1px solid #E5E7EB;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.lp-btn-outline-secondary:hover {
  background: #F9FAFB;
  border-color: #D1D5DB;
  color: #000;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.lp-btn-primary-lg {
  padding: 16px 36px;
  font-size: 16px;
  border-radius: var(--radius-full);
  font-weight: 700;
}

/* Mobile menu */
.lp-mobile-toggle {
  display: none;
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
}
.lp-mobile-toggle span {
  display: block;
  width: 24px;
  height: 2px;
  background: #fff;
  border-radius: 2px;
  transition: all 0.3s;
}
.lp-navbar.scrolled .lp-mobile-toggle span { background: var(--color-text-primary); }

/* ===== LAYOUT ===== */
.lp-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
.lp-container-wide {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 24px;
}
.lp-container-fluid {
  width: 100%;
  padding: 0 24px;
}
.lp-section-label {
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-accent-dark);
  margin-bottom: 12px;
}
.lp-section-title {
  font-family: var(--font-heading);
  font-size: clamp(32px, 5vw, 48px);
  font-weight: 800;
  line-height: 1.15;
  color: var(--color-text-primary);
  margin-bottom: 16px;
}
.lp-section-subtitle {
  font-size: 18px;
  color: var(--color-text-secondary);
  max-width: 640px;
  margin: 0 auto 48px;
  line-height: 1.7;
}

/* ===== HERO ===== */
.lp-hero {
  background: linear-gradient(160deg, #0F172A 0%, #1E293B 50%, #0F172A 100%);
  padding: 180px 0 60px;
  position: relative;
  overflow: hidden;
}
.lp-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -30%;
  width: 80%;
  height: 200%;
  background: radial-gradient(circle, rgba(99,91,255,0.12) 0%, transparent 70%);
  animation: lp-hero-glow 8s ease-in-out infinite alternate;
}
.lp-hero::after {
  content: '';
  position: absolute;
  bottom: -50%;
  right: -30%;
  width: 60%;
  height: 160%;
  background: radial-gradient(circle, rgba(0,212,255,0.08) 0%, transparent 70%);
  animation: lp-hero-glow 10s ease-in-out infinite alternate-reverse;
}
@keyframes lp-hero-glow {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(40px, -20px) scale(1.1); }
}
.lp-hero .lp-container {
  position: relative;
  z-index: 2;
  text-align: center;
}
.lp-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border-radius: var(--radius-full);
  background: rgba(99,91,255,0.15);
  border: 1px solid rgba(99,91,255,0.3);
  color: #A5B4FC;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 32px;
  animation: lp-badge-float 3s ease-in-out infinite;
}
@keyframes lp-badge-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}
.lp-hero-badge .dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  background: #10B981;
  box-shadow: 0 0 8px rgba(16,185,129,0.6);
  animation: lp-pulse-dot 2s ease-in-out infinite;
}
@keyframes lp-pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
.lp-hero h1 {
  font-family: var(--font-heading);
  font-size: clamp(40px, 6vw, 72px);
  font-weight: 800;
  line-height: 1.08;
  color: #fff;
  margin-bottom: 24px;
  letter-spacing: -1px;
}
.lp-gradient-text {
  background: var(--gradient-accent);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.lp-hero-description {
  font-size: clamp(16px, 2vw, 20px);
  color: rgba(255,255,255,0.6);
  max-width: 640px;
  margin: 0 auto 40px;
  line-height: 1.7;
}
.lp-hero-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 56px;
}
.lp-btn-hero-secondary {
  padding: 16px 36px;
  border-radius: var(--radius-full);
  font-size: 16px;
  font-weight: 600;
  color: rgba(255,255,255,0.9);
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  transition: all 0.3s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}
.lp-btn-hero-secondary:hover {
  background: rgba(255,255,255,0.14);
  border-color: rgba(255,255,255,0.3);
  transform: translateY(-1px);
}
.lp-hero-social-proof {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
}
.lp-hero-stat-value {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}
.lp-hero-stat-label {
  font-size: 13px;
  color: rgba(255,255,255,0.45);
  margin-top: 2px;
}
.lp-hero-stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255,255,255,0.12);
}

/* ===== HOW IT WORKS ===== */
.lp-how-it-works {
  padding: 100px 0 40px;
  text-align: center;
  background: #ffffff;
}
.lp-steps-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  margin-top: 48px;
  position: relative;
}
.lp-steps-grid::before {
  content: '';
  position: absolute;
  top: 48px;
  left: 16%;
  right: 16%;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--color-accent), transparent);
  opacity: 0.2;
}
.lp-step-card {
  padding: 20px 16px;
  text-align: center;
  position: relative;
}
.lp-step-number {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--gradient-accent);
  color: #fff;
  font-family: var(--font-heading);
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  box-shadow: 0 4px 20px rgba(99,91,255,0.25);
  position: relative;
  z-index: 1;
}
.lp-step-icon {
  margin-bottom: 24px; /* Increased margin for the larger icons */
}
.lp-step-card h3 {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 12px;
}
.lp-step-card p {
  font-size: 15px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

/* ===== FEATURES ===== */
.lp-features {
  padding: 100px 0;
  background: #fff;
  text-align: center;
}
.lp-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  margin-top: 48px;
}
.lp-feature-card {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 36px 28px;
  text-align: left;
  transition: all 0.4s var(--ease-spring);
  position: relative;
  overflow: hidden;
}
.lp-feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-accent);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s var(--ease-spring);
}
.lp-feature-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(99,91,255,0.2);
}
.lp-feature-card:hover::before {
  transform: scaleX(1);
}
.lp-feature-icon {
  width: 52px;
  height: 52px;
  border-radius: var(--radius-md);
  background: var(--gradient-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 20px;
  transition: transform 0.3s var(--ease-spring);
}
.lp-feature-card:hover .lp-feature-icon {
  transform: scale(1.08) rotate(-3deg);
}
.lp-feature-card h3 {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 10px;
}
.lp-feature-card p {
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

/* ===== DEMO SHOWCASE ===== */
.lp-demo-showcase {
  padding: 100px 0;
  background: linear-gradient(160deg, #0F172A 0%, #1E293B 50%, #0F172A 100%);
  overflow: hidden;
  position: relative;
}
.lp-demo-showcase::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 50% 0%, rgba(99,91,255,0.15) 0%, transparent 70%);
}
.lp-demo-showcase .lp-container { position: relative; z-index: 2; }
.lp-demo-showcase .lp-section-label { color: #A5B4FC; }
.lp-demo-content {
  display: flex;
  align-items: center;
  gap: 60px;
}
.lp-demo-text { flex: 1; text-align: left; }
.lp-demo-text h3 {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
}
.lp-demo-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.lp-demo-list-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.lp-demo-list-check {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(16,185,129,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.lp-demo-list-check svg {
  width: 14px;
  height: 14px;
  color: #10B981;
}
.lp-demo-list-item p {
  font-size: 15px;
  color: rgba(255,255,255,0.7);
  line-height: 1.6;
}
.lp-demo-visual {
  flex: 1;
  max-width: 500px;
}
.lp-demo-card {
  background: rgba(255,255,255,0.06);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: var(--radius-lg);
  padding: 32px;
  transition: transform 0.4s;
}
.lp-demo-card:hover {
  transform: translateY(-4px);
}
.lp-demo-review {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.lp-demo-review-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.lp-demo-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F97316, #EF4444);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
}
.lp-demo-review-meta h4 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
.lp-demo-review-meta .stars {
  color: #FBBF24;
  font-size: 13px;
  letter-spacing: 2px;
}
.lp-demo-review-text {
  font-size: 14px;
  color: rgba(255,255,255,0.6);
  line-height: 1.6;
  font-style: italic;
}
.lp-demo-reply-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--color-accent-light);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.lp-ai-badge {
  padding: 2px 8px;
  background: rgba(99,91,255,0.2);
  border-radius: var(--radius-full);
  font-size: 10px;
  color: #A5B4FC;
}
.lp-demo-reply-text {
  font-size: 14px;
  color: rgba(255,255,255,0.8);
  line-height: 1.7;
}

.lp-demo-insights {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px;
}

.lp-demo-insights-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.lp-demo-insights-header svg {
  color: var(--color-accent);
}

.lp-demo-insights-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lp-demo-insight {
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 8px;
}

.lp-demo-insight.positive {
  background: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.lp-demo-insight.negative {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.lp-demo-insight strong {
  font-weight: 600;
  margin-right: 4px;
  color: #fff;
}
.lp-demo-reply-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}
.lp-demo-btn {
  padding: 8px 16px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.25s;
}
.lp-demo-btn-publish {
  background: var(--gradient-accent);
  color: #fff;
}
.lp-demo-btn-publish:hover { box-shadow: 0 4px 16px rgba(99,91,255,0.3); }
.lp-demo-btn-regen {
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.12);
}
.lp-demo-btn-regen:hover { background: rgba(255,255,255,0.12); }

/* ===== PRICING ===== */
.lp-pricing {
  padding: 100px 0;
  text-align: center;
  background: var(--color-bg);
}
.lp-pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  align-items: stretch;
}
.lp-pricing-card {
  background: var(--color-surface-solid);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: 40px 32px;
  text-align: left;
  position: relative;
  transition: all 0.4s var(--ease-spring);
  display: flex;
  flex-direction: column;
}
.lp-pricing-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-xl);
}
.lp-pricing-card.popular {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 1px var(--color-accent), var(--shadow-lg);
}
.lp-pricing-popular-badge {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 20px;
  border-radius: var(--radius-full);
  background: var(--gradient-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 16px rgba(99,91,255,0.25);
  white-space: nowrap;
}
.lp-pricing-plan-name {
  font-family: var(--font-heading);
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 8px;
}
.lp-pricing-plan-desc {
  font-size: 14px;
  color: var(--color-text-muted);
  margin-bottom: 24px;
  min-height: 40px;
}
.lp-pricing-amount {
  font-family: var(--font-heading);
  font-size: 48px;
  font-weight: 800;
  color: var(--color-text-primary);
  line-height: 1;
}
.lp-pricing-amount .currency {
  font-size: 24px;
  font-weight: 600;
  vertical-align: top;
  margin-right: 4px;
}
.lp-pricing-period {
  font-size: 14px;
  color: var(--color-text-muted);
  margin-top: 4px;
  margin-bottom: 28px;
}
.lp-pricing-features {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}
.lp-pricing-feature {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: var(--color-text-secondary);
}
.lp-pricing-feature svg {
  width: 18px;
  height: 18px;
  color: var(--color-success);
  flex-shrink: 0;
}
.lp-pricing-feature.disabled {
  color: var(--color-text-muted);
}
.lp-pricing-feature.disabled svg {
  color: var(--color-text-muted);
  opacity: 0.4;
}
.lp-pricing-cta {
  width: 100%;
  padding: 14px;
  border-radius: var(--radius-full);
  font-size: 15px;
  font-weight: 700;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
  display: block;
}
.lp-pricing-cta.outline {
  background: transparent;
  color: var(--color-text-primary);
  border: 2px solid var(--color-border);
}
.lp-pricing-cta.outline:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
  background: rgba(99,91,255,0.04);
}
.lp-pricing-cta.gradient {
  background: var(--gradient-accent);
  color: #fff;
  border: none;
  box-shadow: 0 4px 16px rgba(99,91,255,0.25);
}
.lp-pricing-cta.gradient:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(99,91,255,0.3);
}
.lp-pricing-addons {
  margin-top: 48px;
  padding: 32px;
  background: var(--color-surface-solid);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  display: inline-flex;
  gap: 48px;
  align-items: center;
}
.lp-addon-item h3 {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text-primary);
}
.lp-addon-item p {
  font-size: 13px;
  color: var(--color-text-muted);
}
.lp-addon-divider {
  width: 1px;
  height: 40px;
  background: var(--color-border);
}

/* ===== TESTIMONIALS ===== */
.lp-testimonials {
  padding: 100px 0;
  background: #fff;
  text-align: center;
}
.lp-testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  margin-top: 48px;
}
.lp-testimonial-card {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 32px;
  text-align: left;
  transition: all 0.4s var(--ease-spring);
}
.lp-testimonial-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}
.lp-testimonial-stars {
  color: #FBBF24;
  font-size: 16px;
  letter-spacing: 2px;
  margin-bottom: 16px;
}
.lp-testimonial-text {
  font-size: 15px;
  color: var(--color-text-secondary);
  line-height: 1.7;
  margin-bottom: 20px;
  font-style: italic;
}
.lp-testimonial-author {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lp-testimonial-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.lp-testimonial-author-info h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}
.lp-testimonial-author-info p {
  font-size: 13px;
  color: var(--color-text-muted);
}

/* ===== CONTACT ===== */
.lp-contact {
  padding: 100px 0;
  text-align: center;
  background: #fff;
}
.lp-contact-card {
  max-width: 680px;
  margin: 0 auto;
  background: var(--color-surface-solid);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: 48px;
  box-shadow: var(--shadow-lg);
}
.lp-contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
}
.lp-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.lp-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.lp-form-group label {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}
.lp-form-group input,
.lp-form-group textarea,
.lp-form-group select {
  padding: 12px 16px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-size: 15px;
  color: var(--color-text-primary);
  background: var(--color-bg);
  transition: all 0.25s;
  outline: none;
  font-family: inherit;
}
.lp-form-group input:focus,
.lp-form-group textarea:focus,
.lp-form-group select:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px rgba(99,91,255,0.15);
}
.lp-form-group textarea {
  resize: vertical;
  min-height: 120px;
}
.lp-contact-submit {
  width: 100%;
  padding: 14px;
  margin-top: 8px;
}

/* ===== BLOG PREVIEW ===== */
.lp-blog-preview {
  padding: 100px 0;
  background: linear-gradient(160deg, #0F172A 0%, #1E293B 50%, #0F172A 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}
.lp-blog-preview::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -20%;
  width: 60%;
  height: 160%;
  background: radial-gradient(circle, rgba(99,91,255,0.1) 0%, transparent 70%);
  pointer-events: none;
}
.lp-blog-preview .lp-container {
  position: relative;
  z-index: 2;
}
.lp-blog-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 48px;
}
.lp-blog-card {
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: var(--radius-lg);
  padding: 0;
  text-align: left;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: all 0.4s var(--ease-spring);
}

.lp-blog-card-cover {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.lp-blog-card-offset {
  transform: translateY(32px);
}

.lp-blog-card-offset:hover {
  transform: translateY(26px); /* 32 - 6 for hover effect */
}

.lp-blog-card-body {
  padding: 24px 28px 28px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.lp-blog-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-accent);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s var(--ease-spring);
}
.lp-blog-card:hover {
  transform: translateY(-6px);
  background: rgba(255,255,255,0.08);
  border-color: rgba(99,91,255,0.3);
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}
.lp-blog-card:hover::before {
  transform: scaleX(1);
}
.lp-blog-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}
.lp-blog-card-tag {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 3px 10px;
  border-radius: var(--radius-full);
  background: rgba(99,91,255,0.2);
  color: #A5B4FC;
}
.lp-blog-card-title {
  font-family: var(--font-heading);
  font-size: 19px;
  font-weight: 700;
  line-height: 1.35;
  color: #fff;
  margin-bottom: 12px;
}
.lp-blog-card-excerpt {
  font-size: 14px;
  color: rgba(255,255,255,0.5);
  line-height: 1.7;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.lp-blog-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(255,255,255,0.06);
  font-size: 13px;
  color: rgba(255,255,255,0.35);
}
.lp-blog-card-read {
  color: var(--color-accent-light);
  font-weight: 600;
  transition: all 0.2s;
}
.lp-blog-card:hover .lp-blog-card-read {
  letter-spacing: 0.5px;
}

/* ===== CTA BANNER ===== */
.lp-cta-banner {
  padding: 100px 0;
  background: linear-gradient(160deg, #0F172A 0%, #1E293B 50%, #0F172A 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}
.lp-cta-banner::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(99,91,255,0.15) 0%, transparent 70%);
  pointer-events: none;
}
.lp-cta-banner .lp-container { position: relative; z-index: 2; }
.lp-cta-banner h2 {
  font-family: var(--font-heading);
  font-size: clamp(32px, 5vw, 48px);
  font-weight: 800;
  color: #fff;
  margin-bottom: 16px;
  line-height: 1.15;
}
.lp-cta-banner p {
  font-size: 18px;
  color: rgba(255,255,255,0.6);
  margin-bottom: 40px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}
.lp-cta-banner-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* ===== FOOTER ===== */
.lp-footer {
  background: #0B0F1A;
  padding: 64px 0 32px;
  color: #fff;
}
.lp-footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 48px;
}
.lp-footer-brand .lp-footer-logo {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.lp-footer-brand p {
  font-size: 15px;
  line-height: 1.7;
  max-width: 300px;
  color: rgba(255, 255, 255, 0.75);
}
.lp-footer-col h3 {
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
}
.lp-footer-col a {
  display: block;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  padding: 6px 0;
  transition: color 0.25s;
  text-decoration: none;
}
.lp-footer-col a:hover { color: #4F46E5; } /* using a visible accent color instead of text-primary */
.lp-footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}
.lp-footer-bottom p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}
.lp-footer-socials {
  display: flex;
  gap: 12px;
}
.lp-footer-socials a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: #fff;
  transition: all 0.3s ease;
}
.lp-footer-socials a:hover {
  background: #4F46E5;
  color: #fff;
  transform: translateY(-2px);
}
.lp-footer-socials a svg { width: 16px; height: 16px; }

/* ===== RESPONSIVE ===== */
@media (max-width: 1024px) {
  .lp-features-grid,
  .lp-pricing-grid,
  .lp-blog-grid,
  .lp-testimonials-grid { grid-template-columns: 1fr 1fr; }
  .lp-steps-grid { grid-template-columns: 1fr; gap: 24px; }
  .lp-steps-grid::before { display: none; }
  .lp-demo-content { flex-direction: column; }
  .lp-demo-visual { max-width: 100%; }
  .lp-footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
}
@media (max-width: 768px) {
  .lp-navbar { top: var(--demo-banner-height, 90px); }
  .lp-navbar-links { display: none; }
  .lp-mobile-toggle { display: flex; }
  .lp-features-grid,
  .lp-pricing-grid,
  .lp-blog-grid,
  .lp-testimonials-grid { grid-template-columns: 1fr; }
  .lp-hero { padding: 140px 0 80px; }
  .lp-hero h1 { font-size: 36px; }
  .lp-form-row { grid-template-columns: 1fr; }
  .lp-footer-grid { grid-template-columns: 1fr; gap: 32px; }
  .lp-pricing-addons { flex-direction: column; gap: 24px; }
  .lp-addon-divider { width: 100%; height: 1px; }
  .lp-hero-social-proof { gap: 20px; }
  .lp-contact-card { padding: 32px 20px; }
  .lp-section-title { font-size: 28px; }

  /* Hide entire actions bar on mobile — Login & Start Free move into hamburger menu */
  .lp-navbar-actions { display: none; }

  .lp-navbar-links.open {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(15, 23, 42, 0.98);
    backdrop-filter: blur(16px);
    padding: 24px;
    gap: 16px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  .lp-navbar.scrolled .lp-navbar-links.open {
    background: rgba(255,255,255,0.98);
  }

  /* Show mobile-only items inside the menu */
  .lp-navbar-links.open .lp-mobile-only { display: list-item; }
  .lp-mobile-login {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
  .lp-mobile-signup {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
  .lp-mobile-lang {
    display: flex;
    justify-content: center;
    padding-top: 8px;
    border-top: 1px solid rgba(255,255,255,0.1);
  }
  .lp-navbar.scrolled .lp-mobile-lang {
    border-top-color: rgba(0,0,0,0.08);
  }
}
/* Hide mobile-only items on desktop */
.lp-mobile-only { display: none; }

@media (max-width: 480px) {
  .lp-hero-actions { flex-direction: column; width: 100%; }
  .lp-hero-actions a { width: 100%; text-align: center; justify-content: center; }
  
  .lp-navbar-logo { font-size: 22px; gap: 6px; }
  .lp-logo-img { height: 24px; }
  .lp-btn-primary { 
    padding: 8px 16px; 
    font-size: 13px; 
    white-space: nowrap; 
  }
}

/* ===== EXTRACTED INLINE STYLES ===== */
.lp-logo-img {
  height: 32px;
}

.lp-features-secondary {
  background: var(--color-bg-secondary);
}

.lp-features-grid-auto {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.lp-feature-link {
  display: inline-block;
  margin-top: 12px;
  color: var(--color-accent);
  font-weight: 600;
}

.lp-feature-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.lp-btn-primary-sm {
  padding: 8px 16px;
  font-size: 14px;
  text-decoration: none;
}

.lp-pricing-toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
}

.lp-pricing-toggle-label {
  font-size: 18px;
  font-weight: 500;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.lp-pricing-badge {
  background: rgba(16, 185, 129, 0.2);
  color: #10B981;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: bold;
}

.lp-pricing-plan-desc-note {
  font-size: 0.9em;
  opacity: 0.8;
  margin-top: 4px;
}

.lp-pricing-amount-strikethrough {
  text-decoration: line-through;
  opacity: 0.5;
}

.lp-pricing-period-note {
  font-size: 0.85em;
  opacity: 0.8;
}

.lp-section-label-light {
  color: #A5B4FC;
}

.lp-section-title-light {
  color: #fff;
}

.lp-section-subtitle-light {
  color: rgba(255, 255, 255, 0.55);
}

.lp-blog-view-all {
  text-align: center;
  margin-top: 80px;
}

.lp-btn-primary-md {
  padding: 14px 40px;
  font-size: 16px;
}

.lp-contact-submit-success {
  background: linear-gradient(135deg, #10B981, #34D399) !important;
}

/* ===== FEATURES SHOWCASE (NEW) ===== */
.lp-features-showcase {
  padding: 60px 0 100px;
  background: linear-gradient(180deg, #F1F5F9 0%, #FFFFFF 100%);
  text-align: center;
}

.lp-slider-container {
  width: 100%;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  margin-top: 48px;
  padding-bottom: 24px; /* Space for hover effects */
}

.lp-slider-container::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.lp-slider-track {
  display: flex;
  gap: 24px;
  padding: 0 40px;
  width: max-content;
}

.lp-showcase-card {
  width: 500px;
  max-width: 100%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  border-radius: var(--radius-lg);
  padding: 48px 36px;
  text-align: left;
  text-decoration: none;
  transition: all 0.4s var(--ease-spring);
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  overflow: hidden;
  scroll-snap-align: center;
  flex-shrink: 0;
}

.lp-showcase-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; height: 100%;
  background: linear-gradient(135deg, rgba(99,91,255,0.05) 0%, transparent 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.lp-showcase-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(99,91,255,0.12);
  border-color: rgba(99,91,255,0.2);
}

.lp-showcase-card:hover::before {
  opacity: 1;
}

.lp-showcase-icon {
  width: 72px;
  height: 72px;
  border-radius: var(--radius-md);
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.lp-showcase-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lp-showcase-content h3 {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 800;
  color: var(--color-text-primary);
}

.lp-showcase-content p {
  font-size: 16px;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

.lp-showcase-link {
  margin-top: 12px;
  font-size: 16px;
  font-weight: 700;
  color: var(--color-accent);
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s;
}

.lp-showcase-card:hover .lp-showcase-link {
  transform: translateX(6px);
}

/* Slider Navigation */
.lp-slider-wrapper {
  position: relative;
  width: 100%;
  padding: 0 60px; /* space for the arrows */
}

.lp-slider-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: var(--color-text-primary);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  z-index: 10;
}

.lp-slider-arrow:hover {
  background: var(--color-bg-secondary);
  color: var(--color-accent);
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
  transform: translateY(-50%) scale(1.05);
}

.lp-slider-arrow-left {
  left: 0;
}

.lp-slider-arrow-right {
  right: 0;
}

@media (max-width: 768px) {
  .lp-slider-wrapper {
    padding: 0 16px;
  }
  .lp-slider-arrow {
    display: none;
  }
  .lp-slider-container {
    overflow-x: visible;
    scroll-snap-type: none;
    margin-top: 24px;
    padding-bottom: 0;
  }
  .lp-slider-track {
    flex-direction: column;
    width: 100%;
    padding: 0;
    gap: 16px;
  }
  .lp-showcase-card {
    width: 100%;
    margin-bottom: 0;
  }
}

/* Trust Badges */
.trust-badges-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 500;
}

.trust-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.02em;
}

.trust-badge.badge-green {
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.2);
  color: #34D399;
}

.trust-badge.badge-indigo {
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #818CF8;
}

.trust-badge-link {
  display: flex;
  align-items: center;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}
.trust-badge-link:hover {
  opacity: 1;
}

.trust-badge-img {
  height: 28px;
  width: auto;
}
